import { render, staticRenderFns } from "./gallery.vue?vue&type=template&id=3de71aae"
import script from "./gallery.ts?vue&type=script&lang=ts&external"
export * from "./gallery.ts?vue&type=script&lang=ts&external"
import style0 from "./gallery.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports